import { MapPin, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const communities = ["Los Angeles", "Burbank", "Glendale", "Pasadena", "Santa Monica", "Culver City", "Long Beach", "Anaheim", "Santa Ana", "Van Nuys", "Torrance", "North Hollywood"];
export default function ServiceAreaMap() {
  return <section id="serviceareamap" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mb-10 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
            Southern California Service Area
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Communities & Coverage Notes */}
          <div className="lg:col-span-5 flex flex-col gap-6">
            <div className="rounded-xl border border-border bg-card p-6 md:p-8 shadow-xs">
              <h3 className="text-lg font-semibold text-card-foreground mb-4">
                Representative Served Communities
              </h3>
              <ul className="grid grid-cols-2 gap-x-4 gap-y-3">
                {communities.map((city, i) => <li key={city} data-index={i} className="flex items-center gap-2 text-sm text-card-foreground/90">
                    <MapPin className="size-4 shrink-0 text-primary" aria-hidden="true" />
                    <span>{city}</span>
                  </li>)}
              </ul>
              <div className="mt-6 pt-6 border-t border-border/80">
                <p className="text-xs text-muted-foreground leading-relaxed">
                  Listing a community does not guarantee availability or delivery — coverage is confirmed with each quote.
                </p>
              </div>
            </div>
          </div>

          {/* Embedded Google Map */}
          <div className="lg:col-span-7 flex flex-col gap-4">
            <div className="relative w-full aspect-16/10 sm:aspect-16/9 rounded-xl overflow-hidden border border-border bg-muted shadow-sm">
              <iframe src="https://www.google.com/maps?q=13726+Saticoy+Street,+Panorama+City,+California&z=10&output=embed" width="100%" height="100%" loading="lazy" title="Fridge Fleet Los Angeles / Southern California service base" aria-label="Fridge Fleet Los Angeles / Southern California service base" className="w-full h-full border-0" allowFullScreen />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pt-1">
              <p className="text-xs text-muted-foreground max-w-xl order-2 sm:order-1 leading-relaxed">
                Map location represents a Fridge Fleet service base. Delivery coverage, trailer availability, and requirements are confirmed with each quote.
              </p>
              <div className="order-1 sm:order-2 shrink-0">
                <Button variant="outline" size="sm" asChild>
                  <Link to="https://maps.google.com/?q=13726+Saticoy+Street+Panorama+City+California" newTab className="gap-2">
                    <span>Open in Google Maps</span>
                    <ExternalLink className="size-3.5" aria-hidden="true" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}